import { DELETE_SITE, DELETE_SITE_ERROR } from 'modules/sites/action-types'
import { getFirstAccount } from 'modules/accounts'
import { getAuthToken } from 'modules/auth';
import { SITE_DELETE_API } from 'config';


export default ({ dispatch, getState }) => next => action => {
  const result = next(action)

  if (typeof action === 'object' && action.type === DELETE_SITE) {
    const accountId = getFirstAccount(getState()).key;
    getAuthToken().then(idToken => {
      return fetch(`${SITE_DELETE_API}/${accountId}/${action.payload.key}`, {
        method: 'GET',
        headers: new Headers({
          'Authorization': 'Bearer ' + idToken,
          'Content-Type': 'application/json'
        })
      });
    })
      .catch(e => { dispatch({type: DELETE_SITE_ERROR, payload: e.message}) });
  }

  return result
}



// WEBPACK FOOTER //
// ./src/redux/middlewares/cascadeDeleting.js